const AUTH_QUERY_KEY_PREFIX = 'auth';

const AuthMutationKeys = {
  PROVE_PREFILL_INITIALIZE: () => [AUTH_QUERY_KEY_PREFIX, 'prove-prefill', 'initialize'],
  PROVE_PREFILL_VERIFY: () => [AUTH_QUERY_KEY_PREFIX, 'prove-prefill', 'verify'],
};

export { AUTH_QUERY_KEY_PREFIX, AuthMutationKeys };
